<template>
	<div>
		<div class="md-layout md-gutter md-alignment-center">
			<div v-for="item in modules" :key="item.name" class="card">
				<md-card>
					<md-card-header :style="{ backgroundColor: item.colour }">
						<md-card-header-text>
							<div style="color: white; display: flex">
								<md-icon style="color: white; margin-top: auto; margin-bottom: auto; margin-left: 0">{{
									item.icon
								}}</md-icon>
								<span style="margin: auto auto auto 10px">{{ $t(item.name).toUpperCase() }}</span>
								<!--<md-menu md-direction="bottom-start">
                  <md-button class="md-icon-button" style="margin-left: auto; margin-right: 0" md-menu-trigger>
                    <md-icon style="color: white">more_vert</md-icon>
                  </md-button>
                  <md-menu-content>
                    <div style="padding: 10px" v-if="!available(item)">
                      <div style="display: flex;">
                        <div style="margin-right: 5px">
                          <span v-if="getItem(item).disabled">{{$t('disable')}}</span>
                          <span v-else>{{$t('able')}}</span>
                        </div>
                        <el-switch style="margin-left: auto; margin-right: 0px"
                                   v-model="getItem(item).disabled" @change="change(item)"
                                   active-color="#ff4949" inactive-color="#13ce66">
                        </el-switch>
                      </div>
                      <md-divider style="margin: 20px 5px"></md-divider>
                      <div style="display: flex">
                        <span style="margin-right: 5px">{{$t('expired-at')}}</span>
                        <span>{{getExpiration(item)}}</span>
                      </div>
                    </div>
                    <div v-else>
                      <md-button @click="renews(item)">rinnova</md-button>
                    </div>
                  </md-menu-content>
                </md-menu>-->
							</div>
						</md-card-header-text>
					</md-card-header>
					<md-card-content>
						<div style="margin-top: 20px">
							<div style="margin-bottom: 20px">
								<span>{{ $t(item.description) }}</span>
							</div>
							<div style="display: flex" v-if="!alreadyBought(item)">
								<span class="price">{{ item.price.toFixed(2) + " $" }}</span>
								<md-button class="button md-icon-button" @click="add(item)">
									<md-icon>get_app</md-icon>
								</md-button>
							</div>
							<div v-else style="width: 100%">
								<span v-if="!available(item)" class="bought">{{ $t("already-bought") }}</span>
								<span v-else class="expired">{{ $t("expired") }}</span>
							</div>
						</div>
					</md-card-content>
				</md-card>
			</div>
		</div>
		<Modal :show="show" @close="show = false" :title="titleModal" :content="contentModal" />
	</div>
</template>

<script>
import axios from "axios"
import { mapActions, mapGetters } from "vuex"
import Modal from "@/modules/_common/modal/simple-modal"

export default {
	name: "ChooseModule",
	components: {
		Modal
	},

	created() {
		axios
			.get(process.env.VUE_APP_API_URL + "/api/organizationmodule", {
				headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
			})
			.then(res => {
				res.data.modules.forEach(element => {
					element.disabled = false
					this.myModules.push(element)
				})
			})
			.catch(err => console.err(err))

		//get available list router-modules (filtered by user/orgazination roles)
		axios
			.get(process.env.VUE_APP_API_URL + "/api/module", {
				headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
			})
			.then(res => {
				res.data.modules.forEach(item => (item.price = 0.0))
				this.modules = res.data.modules
			})
			.catch(err => console.error(err))
	},

	data() {
		return {
			myModules: [],
			modules: [],
			show: false,

			titleModal: "",
			contentModal: ""
		}
	},
	computed: {
		...mapGetters({
			organizationModules: "organization/modules"
		})
	},
	methods: {
		...mapActions({
			addModule: "organization/addModule"
		}),

		async add(item) {
			if (item.price == 0) {
				var today = new Date()
				var date = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate())
				var payload = {
					module_id: item.id,
					expiration: date,
					active: true
				}

				var result = await this.addModule(payload)
				if (result) {
					this.show = true
					this.titleModal = this.$t("operation-completed-title")
					this.contentModal = this.$t("operation-completed-content")
					this.myModules.push(result)
				}
			}
		},

		renews: function (item) {
			var today = new Date()
			var date = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate())
			var element = this.getItem(item)
			var payload = {
				expiration: date
			}
			axios
				.put(process.env.VUE_APP_API_URL + "/api/organizationmodule/" + element.id, payload, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					if (res.data.response) {
						this.$emit("refreshAll")
					}
				})
				.catch(err => console.err(err))
		},

		change: function (item) {},

		alreadyBought: function (item) {
			var found = false
			this.myModules.forEach(element => {
				if (element.module.name == item.name) found = true
			})

			return found
		},

		available: function (item) {
			var value = false
			this.myModules.forEach(element => {
				if (element.module_id == item.id) {
					value = new Date(element.expiration) < new Date()
				}
			})
			return value
		},

		getExpiration: function (item) {
			var value = undefined
			this.myModules.forEach(element => {
				if (element.module_id == item.id) {
					value = element.expiration
				}
			})
			return value.substring(0, 10)
		},

		getItem: function (item) {
			var value = undefined
			this.myModules.forEach(element => {
				if (element.module_id == item.id) {
					value = element
				}
			})
			return value
		}
	}
}
</script>

<style scoped lang="scss">
.card {
	padding: 10px;
	width: 250px;
	margin-left: 10px;
	margin-right: 10px;
}
.price {
	margin-top: auto;
	margin-bottom: auto;
	padding: 4px 10px;
	background-color: #ffa726;
	border-radius: 25px;
	color: white;
}
.button {
	padding: 10px;
	border-radius: 25px;
	font-size: 10px;
	margin-top: auto;
	margin-bottom: auto;
	margin-left: auto;
	margin-right: 0;
}
.bought {
	font-style: italic;
	color: #ffa726;
	font-size: 12px;
}
.expired {
	font-style: italic;
	color: red;
	font-size: 12px;
}
</style>
